import { useMediaQuery, useTheme } from '@mui/material';
export var useIsMobile = function (breakpoint) {
    var theme = useTheme();
    return !useMediaQuery(theme.breakpoints.up(breakpoint ? breakpoint : 'lg'));
};
